import {ActionTree} from "vuex";
import {UserState} from "./types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<UserState, RootState> = {

  async getAllowedPages({commit, dispatch},id?:number) {
    try {
      let resp = await axios({url: `/lk-api/allowed-pages`})
      const allowedPages = resp.data?.allowedPages.map((v:any) => v.name)
      commit('setAllowedPages', allowedPages);
      return allowedPages
    } catch(err){
      throw err;
    }
  },

  async getProfile({commit, dispatch})  {
    try {
      return await axios({url: '/lk-api/user/info/profile'})
    } catch (err) {
      throw err;
    }
  },

  async saveProfile({commit, dispatch}, data)  {
    try {
      return await axios({url: '/lk-api/user/info/profile', method: 'put', data})
    } catch (err) {
      throw err;
    }
  },

  async changePassword({commit, dispatch}, data)  {
    try {
      const resp = await axios({url: '/lk-api/user/info/password', method: 'put', data})
      commit('setChangePassword', false);
      localStorage.setItem('lk-incp', 'false')
      return resp
    } catch (err) {
      throw err;
    }
  },

  async getTimeZones({commit, dispatch}) {
    try {
      return await axios({url: '/lk-api/user/info/timezones'})
    } catch (err) {
      throw err;
    }
  },

  async getBalance({commit, dispatch})  {
    try {
      return await axios({url: '/lk-api/user/info/balance'})
    } catch (err) {
      throw err;
    }
  },

  async getSystemSettings({commit, dispatch}, data)  {
    try {
      const resp = await axios({url: '/lk-api/settings/'+data})
      return resp.data.value;
    } catch (err) {
      throw err;
    }
  },

}
